<div class="producer-page">
  <div class="search-container">
    <div class="filter-dropdown">
      <mat-form-field appearance="fill">
        <mat-label class="filter-label">Filter</mat-label>
        <mat-select [formControl]="dropdownFormControl" multiple (selectionChange)="filterItems()" class="filter-select">
          <mat-select-trigger>
            {{dropdownFormControl.value ? dropdownFormControl.value[0] : ''}}
            @if (dropdownFormControl.value?.length > 1) {
              <span class="example-additional-selection">
                (+{{dropdownFormControl.value.length - 1}} {{dropdownFormControl.value?.length === 2 ?
                'other' : 'others'}})
              </span>
            }
          </mat-select-trigger>
          @for (lob of lobFilterValues; track lob) {
            <mat-option [value]="lob">{{lob}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="search-bar">
      <span class="material-symbols-outlined search-icon">search</span>
      <input mat-input [formControl]="searchFormControl" type="search" name="search" placeholder="Search" (input)="filterItems()"/>
    </div>
  </div>
  <div class="media-list">
    @for (mediaCard of filteredCardArray; track mediaCard) {
      <div class="media-card">
        <app-media-card
          [thumbnail]="mediaCard.fileReference_cardThumbnail" [title]="mediaCard.cardTitle" [description]="mediaCard.cardDescription" [tags]="mediaCard.articleTags" [link]="mediaCard.redirectLink" [publishDate]="mediaCard.dateAdded" [altText]="mediaCard.imgAltText">
        </app-media-card>
      </div>
    }
  </div>
</div>